exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep .ui-inputswitch {\n  margin-top: 5px;\n  border-color: #ddd;\n  border-style: solid;\n  border-width: 0;\n  border-radius: 10px;\n  height: 10px;\n  overflow: visible; }\n  :host ::ng-deep .ui-inputswitch .ui-inputswitch-offlabel {\n    background: #505050;\n    color: #505050; }\n  :host ::ng-deep .ui-inputswitch .ui-inputswitch-onlabel {\n    background: #00BBA6;\n    color: #00BBA6; }\n\n:host ::ng-deep .ui-inputswitch-handle {\n  border-color: #ddd;\n  border-style: solid;\n  border-width: 0;\n  background: #eeeeee;\n  height: 20px;\n  top: -5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-form/components/form-switch/form-switch.component.scss
// module id = ../../../../../src/app/modules/ui-form/components/form-switch/form-switch.component.scss
// module chunks = main